import WalletActionTypes from "./wallet.types";

const INITIAL_STATE = {
  countries: [],
  rates: {},
  deposits: [],
  cards: [],
  balance: 0,
  walletHistory: [],
  depositData: null,
  verifyingPaystack: false,
  stripeConnect: {
    connected: false,
    onboarded: false,
    onboardingUrl: null,
  },
  loading: false,
  balanceLoading: true,
  historyLoading: false,
  connectLoading: false,
  error: null,
  successMessage: null,
};

const walletReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Countries
    case WalletActionTypes.FETCH_COUNTRIES_START:
      return { ...state, loading: true, error: null };
    case WalletActionTypes.FETCH_COUNTRIES_SUCCESS:
      return { ...state, loading: false, countries: action.payload };
    case WalletActionTypes.FETCH_COUNTRIES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Location update
    case WalletActionTypes.UPDATE_LOCATION_START:
      return { ...state, loading: true, error: null };
    case WalletActionTypes.UPDATE_LOCATION_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: "Location updated successfully",
      };
    case WalletActionTypes.UPDATE_LOCATION_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Rates
    case WalletActionTypes.FETCH_RATES_START:
      return { ...state, loading: true, error: null };
    case WalletActionTypes.FETCH_RATES_SUCCESS:
      return { ...state, loading: false, rates: action.payload };
    case WalletActionTypes.FETCH_RATES_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Deposit
    case WalletActionTypes.INIT_DEPOSIT_START:
      return { ...state, loading: true, error: null, depositData: null };
    case WalletActionTypes.INIT_DEPOSIT_SUCCESS:
      return {
        ...state,
        loading: false,
        depositData: action.payload,
        successMessage: "Deposit initialized",
      };
    case WalletActionTypes.INIT_DEPOSIT_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case WalletActionTypes.VERIFY_PAYSTACK_PAYMENT_START:
      return { ...state, verifyingPaystack: true, error: null };
    case WalletActionTypes.VERIFY_PAYSTACK_PAYMENT_SUCCESS:
      return {
        ...state,
        verifyingPaystack: false,
        depositData: null,
        successMessage: `Payment successful! ${action.payload.coinsAwarded} LogaCoins credited to your account.`,
        error: null,
      };
    case WalletActionTypes.VERIFY_PAYSTACK_PAYMENT_FAILURE:
      return {
        ...state,
        verifyingPaystack: false,
        error: action.payload,
      };

    // Fetch deposits
    case WalletActionTypes.FETCH_DEPOSITS_START:
      return { ...state, loading: true, error: null };
    case WalletActionTypes.FETCH_DEPOSITS_SUCCESS:
      return { ...state, loading: false, deposits: action.payload };
    case WalletActionTypes.FETCH_DEPOSITS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Withdrawal
    case WalletActionTypes.REQUEST_WITHDRAWAL_START:
      return { ...state, loading: true, error: null };
    case WalletActionTypes.REQUEST_WITHDRAWAL_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessage: "Withdrawal request submitted",
      };
    case WalletActionTypes.REQUEST_WITHDRAWAL_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch saved cards
    case WalletActionTypes.FETCH_CARDS_START:
      return { ...state, loading: true, error: null };
    case WalletActionTypes.FETCH_CARDS_SUCCESS:
      return { ...state, loading: false, cards: action.payload };
    case WalletActionTypes.FETCH_CARDS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Fetch balance
    case WalletActionTypes.FETCH_BALANCE_START:
      return { ...state, balanceLoading: true, error: null };
    case WalletActionTypes.FETCH_BALANCE_SUCCESS:
      return { ...state, balanceLoading: false, balance: action.payload };
    case WalletActionTypes.FETCH_BALANCE_FAILURE:
      return { ...state, balanceLoading: false, error: action.payload };

    // Clear messages
    case WalletActionTypes.CLEAR_WALLET_MESSAGES:
      return { ...state, error: null, successMessage: null };

    // Wallet history
    case WalletActionTypes.FETCH_WALLET_HISTORY_START:
      return { ...state, historyLoading: true, error: null };
    case WalletActionTypes.FETCH_WALLET_HISTORY_SUCCESS:
      return { ...state, historyLoading: false, walletHistory: action.payload };
    case WalletActionTypes.FETCH_WALLET_HISTORY_FAILURE:
      return { ...state, historyLoading: false, error: action.payload };

    // Stripe Connect - Create
    case WalletActionTypes.CREATE_STRIPE_CONNECT_START:
      return { ...state, connectLoading: true, error: null };
    case WalletActionTypes.CREATE_STRIPE_CONNECT_SUCCESS:
      return {
        ...state,
        connectLoading: false,
        stripeConnect: {
          connected: true,
          onboarded: action.payload.onboarded,
          onboardingUrl: action.payload.onboardingUrl,
        },
      };
    case WalletActionTypes.CREATE_STRIPE_CONNECT_FAILURE:
      return { ...state, connectLoading: false, error: action.payload };

    // Stripe Connect - Status
    case WalletActionTypes.FETCH_STRIPE_CONNECT_STATUS_START:
      return { ...state, connectLoading: true, error: null };
    case WalletActionTypes.FETCH_STRIPE_CONNECT_STATUS_SUCCESS:
      return {
        ...state,
        connectLoading: false,
        stripeConnect: {
          connected: action.payload.connected,
          onboarded: action.payload.onboarded,
          onboardingUrl: null,
        },
      };
    case WalletActionTypes.FETCH_STRIPE_CONNECT_STATUS_FAILURE:
      return { ...state, connectLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default walletReducer;
